import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  Stack,
  styled,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import BadgeStepper from 'components/BadgeStepper';

const PaperStyled = styled(Paper)`
  width: 100%;
  padding: 10px;
`;

const ContainerStyle = styled(Container)`
  display: fixed;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const BoxTitleStyle = styled(Typography)(() => ({
  fontWeight: 600,
  backgroundColor: '#FAFAFA',
  padding: 16,
  borderRadius: 4,
  textAlign: 'left'
}));

const ManagementPage = () => {
  const navigate = useNavigate();

  const handleGoToRegistration = () => {
    navigate('/registration');
  };

  const { t } = useTranslation();
  return (
    <ContainerStyle>
      <PaperStyled>
        <Stack>
          <Box>
            <Typography variant="h5">{t('step1.title')}</Typography>
          </Box>
          <Box sx={{ maxWidth: 500, my: 0.5 }}>
            <Typography style={{ whiteSpace: 'pre-line' }} variant="body3">
              {t('step1.desc')}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: 350 }}>
            {/* color not work */}
            <BadgeStepper />
          </Box>
          <Box>
            <Typography variant="h5">Tambahakan Penguna IBB</Typography>
            <Box>
              <Stack>
                <BoxTitleStyle>
                  <Box>
                    {/* form name */}
                    <FormLabel sx={{ padding: '10px' }}>Pengurus</FormLabel>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          sx={{ width: '100%', paddingBottom: 3 }}
                          value="end"
                          control={<Checkbox />}
                          label={
                            <>
                              <Grid container sx={{ width: 'inherit' }}>
                                <Grid md={4}>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Name
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    Jhon Xena
                                  </Typography>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Alamat Email
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    jhonxena@gmail.com
                                  </Typography>
                                </Grid>
                                <Grid md={4}>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Nomor Identitas
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    123455667789625
                                  </Typography>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Nomor Handphone
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    +62 849144911
                                  </Typography>
                                </Grid>
                                <Grid md={4}>
                                  <FormLabel>Level Akses</FormLabel>
                                  <FormControl component="fieldset">
                                    <FormGroup aria-label="position" row>
                                      <FormControlLabel
                                        value="end"
                                        control={<Checkbox />}
                                        label="Membuat Transfer (Maker)"
                                        labelPlacement="end"
                                      />
                                      <FormControlLabel
                                        value="end"
                                        control={<Checkbox />}
                                        label="Mengotorisasi Transfer (Releaser)"
                                        labelPlacement="end"
                                      />
                                    </FormGroup>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </>
                          }
                          labelPlacement="end"
                        />

                        <FormControlLabel
                          sx={{ width: '100%', paddingBottom: 3 }}
                          value="end"
                          control={<Checkbox />}
                          label={
                            <>
                              <Grid container sx={{ width: 'inherit' }}>
                                <Grid md={4}>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Name
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    Jhon Xena
                                  </Typography>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Alamat Email
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    jhonxena@gmail.com
                                  </Typography>
                                </Grid>
                                <Grid md={4}>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Nomor Identitas
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    123455667789625
                                  </Typography>
                                  <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                                    Nomor Handphone
                                  </Typography>
                                  <Typography fontWeight={400} fontSize={12}>
                                    +62 849144911
                                  </Typography>
                                </Grid>
                                <Grid md={4}>
                                  <FormLabel>Level Akses</FormLabel>
                                  <FormControl component="fieldset">
                                    <FormGroup aria-label="position" row>
                                      <FormControlLabel
                                        sx={{ fontSize: 10 }}
                                        value="end"
                                        control={<Checkbox />}
                                        label="Membuat Transfer (Maker)"
                                        labelPlacement="end"
                                      />
                                      <FormControlLabel
                                        sx={{ fontSize: 10 }}
                                        value="end"
                                        control={<Checkbox />}
                                        label="Mengotorisasi Transfer (Releaser)"
                                        labelPlacement="end"
                                      />
                                    </FormGroup>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </>
                          }
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>
                  </Box>
                </BoxTitleStyle>
              </Stack>
            </Box>
            <Box>
              <Stack>
                <BoxTitleStyle>
                  <FormLabel sx={{ padding: '10px' }}>Pengurus</FormLabel>
                  <Box sx={{ px: 5 }}>
                    {/* form name */}
                    <Grid container sx={{ width: 'inherit' }}>
                      <Grid md={4}>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Name
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          Jhon Xena
                        </Typography>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Alamat Email
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          jhonxena@gmail.com
                        </Typography>
                      </Grid>
                      <Grid md={4}>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Nomor Identitas
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          123455667789625
                        </Typography>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Nomor Handphone
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          +62 849144911
                        </Typography>
                      </Grid>
                      <Grid md={4}>
                        <FormLabel>Level Akses</FormLabel>
                        <Typography fontWeight={400} fontSize={12} sx={{ py: 0.5 }}>
                          Membuat Transfer (Maker)
                        </Typography>
                      </Grid>
                    </Grid>
                    {/* line2 */}
                    <Grid container sx={{ width: 'inherit' }}>
                      <Grid md={4}>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Name
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          Jhon Xena
                        </Typography>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Alamat Email
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          jhonxena@gmail.com
                        </Typography>
                      </Grid>
                      <Grid md={4}>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Nomor Identitas
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          123455667789625
                        </Typography>
                        <Typography sx={{ py: 0.5 }} fontWeight={600} fontSize={12}>
                          Nomor Handphone
                        </Typography>
                        <Typography fontWeight={400} fontSize={12}>
                          +62 849144911
                        </Typography>
                      </Grid>
                      <Grid md={4}>
                        <FormLabel>Level Akses</FormLabel>
                        <Typography fontWeight={400} fontSize={12} sx={{ py: 1 }}>
                          Membuat Transfer (Maker)
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </BoxTitleStyle>
              </Stack>
            </Box>
          </Box>
          <Box sx={{ maxWidth: 500, py: 7 }}>
            <Button sx={{ border: 1, px: 10, mx: 1 }}> Kembali </Button>
            <Button variant="contained" sx={{ px: 10, mx: 1 }} onClick={handleGoToRegistration}>
              Lanjut
            </Button>
          </Box>
        </Stack>
      </PaperStyled>
    </ContainerStyle>
  );
};

export default ManagementPage;
